<template>
  <div class="layout admin-layout">
    <header class="border-bottom bg-white" v-if="showAdminNavbar">
      <b-container fluid>
        <b-row>
          <b-col>

            <b-navbar class="p-0">
              <b-navbar-nav>
                <b-nav-item-dropdown no-caret>
                  <template v-slot:button-content><font-awesome-icon icon="bars"/></template>
                  <b-dropdown-header>
                    <p class="m-0">Hello {{ `${user.firstName}`.trim() }} 👋<br/><small>{{ user.emailAddress }}</small></p>
                  </b-dropdown-header>
                  <template v-if="companyID">
                    <b-dropdown-divider/>
                    <b-dropdown-item :to="{ name: 'CompanyDashboard', params: { companyID } }">
                      <div class="icon mr-1"><font-awesome-icon icon="tachometer-alt"/></div>
                      Dashboard
                    </b-dropdown-item>
                    <b-dropdown-item :to="{ name: 'JobIndexTaxonomy', params: { companyID } }">
                      <div class="icon mr-1"><font-awesome-icon icon="briefcase"/></div>
                      Job Taxonomy
                    </b-dropdown-item>
                    <b-dropdown-item :to="{ name: 'ManageAnalytics', params: { companyID } }">
                      <div class="icon mr-1"><font-awesome-icon icon="chart-area"/></div>
                      Stats
                    </b-dropdown-item>
                    <b-dropdown-divider/>
                    <b-dropdown-item :to="{ name: 'CompanyLogout', params: { companyID } }">
                      <div class="icon mr-1"><font-awesome-icon icon="lock"/></div>
                      Sign out of Company
                    </b-dropdown-item>
                  </template>
                  <b-dropdown-item :to="{ name: 'Logout' }">
                    <div class="icon mr-1"><font-awesome-icon icon="sign-out-alt"/></div>
                    Sign out of Admin
                  </b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item :to="{ name: 'Welcome' }">
                  <b-img class="admin-logo" src="/static/images/logos/big-logo.svg"/>
                </b-nav-item>
              </b-navbar-nav>

              <b-navbar-nav class="ml-auto mr-2">
                <!-- <b-nav-item>
                  <font-awesome-icon icon="search" />
                </b-nav-item> -->
                <!-- <b-nav-item>
                  <font-awesome-icon icon="bell" />
                </b-nav-item> -->
                <b-nav-item-dropdown right v-if="$route.name !== 'Welcome' && companyList.length > 1">
                  <template v-slot:button-content>
                    <template v-if="selectedCompany">
                      <p class="mb-0 d-none d-md-inline-block"><strong>{{ selectedCompany.name }}</strong></p>
                      <b-img :blank="!selectedCompany.smallLogo" :blank-color="selectedCompany.primaryColour || '#ccc'"
                        :src="selectedCompany.smallLogo" width="24px"/>
                    </template>
                    <span v-else class="d-none d-md-inline-block">Choose...</span>
                  </template>
                  <template v-if="companyList.length > 1">
                    <b-dropdown-item v-for="company in companyDropdownList" :key="company.id" :to="{
                      name: $route.name,
                      params: { ...($route.params || {}), companyID: company.id },
                      query: $route.query,
                      hash: $route.hash,
                    }">
                      <b-media right-align>
                        <template v-slot:aside>
                          <b-img :blank="!company.smallLogo" :blank-color="company.primaryColour || '#ccc'"
                            :src="company.smallLogo" height="28px" width="28px"/>
                        </template>
                        <p class="mb-0">
                          <strong v-if="selectedCompany && selectedCompany.id === company.id">{{ company.name }}</strong>
                          <template v-else>{{ company.name }}</template>
                        </p>
                      </b-media>
                    </b-dropdown-item>
                  </template>
                </b-nav-item-dropdown>
              </b-navbar-nav>

              <b-navbar-nav>
                <b-button v-b-modal.add-new-company variant="primary">Add New</b-button>
              </b-navbar-nav>

              <b-modal id="add-new-company" size="lg" title="Create Company" hide-footer>
                <advanced-form
                  v-if="!displayText && !isLoading"
                  autocomplete="off"
                  layout="inline-md-3"
                  submit-label="Create"
                  v-bind="formFields"
                  v-model="form"
                  @submit="input()"
                />
                <div
                  v-else-if="!setupCompanyInstructions && !isLoading"
                >
                  <u><p>You are about to create a campaign with the following details: </p></u>
                  <ul>
                    <li>Company Name: <b>{{ this.form.companyName }}</b></li>
                    <li>Domain Name: <b>{{ this.form.domain }}.reallinks.io</b></li>
                    <li>Campaign Start Date: <b>{{ this.form.startDate }}</b></li>
                    <li>Jam Duration: <b>{{ this.form.jamDuration }} minutes</b></li>
                  </ul>

                  <p>Are these details <b><span style="color: green;">correct?</span></b></p>
                  <p>Once a company is created, you <b><span style="color: red;">cannot</span></b> change its name and domain</p>
                  <b-container>
                    <b-row class="text-center" align-v="center">
                      <b-col>
                        <b-btn variant="link" @click="goBack()">Go Back</b-btn>
                      </b-col>
                      <b-col>
                        <b-btn variant="primary" @click="confirmInput()">Confirm and Create</b-btn>
                      </b-col>
                    </b-row>
                  </b-container>
                </div>
                <div v-else-if="isLoading" class="d-flex justify-content-center py-5 w-100">
                  <loading-spinner/>
                </div>
                <div v-else-if="setupCompanyInstructions">
                  <p>Congratulations! The company is now successfully created.</p>
                  <p>Follow the instructions below to finish setting up the instance and campaign in no time.</p>
                  <ol>
                    <li>Copy the following magic link and save it as <b>you will need it later</b>:<br>
                      <b-alert show>{{setupCompanyInstructions.magicLink}}</b-alert>
                    </li>
                    <li>Once these instructions are closed scroll to the company you created and <b>click on the globe icon</b>. (Refresh the page if you cannot find the company.)</li>
                    <li>Once the new portal is done loading paste in the magic link to the same browser window and follow the instructions.</li>
                  </ol>
                  <p>You can now close this modal.</p>
                </div>
              </b-modal>

            </b-navbar>

          </b-col>
        </b-row>
      </b-container>
    </header>

    <b-container fluid>
      <b-row>
        <b-col>
          <slot :companyID="companyID"/>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid>
      <b-row class="mt-5">
        <b-col class="text-center mt-5">
          <ul class="list-inline">
            <li class="list-inline-item">Powered by Real Links</li>
          </ul>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import AdvancedForm from '@src/components/AdvancedForm';
import _sortBy from 'lodash/sortBy';
import Vue from 'vue';
import { adminAPI, getCurrentCompanyID, getCognitoUser, companyStartSession } from '@src/lib/admin';
import LoadingSpinner from '@src/components/misc/LoadingSpinner';
import { mapRoot } from '@/mixins/root';

const EXCEMPT_ROUTES = [
  'CompanyLogin',
  'CompanyLogout',
];
const DEVELOPER_EMAILS = [
  'marton.takacs@reallinks.io',
  'tom.waddington@reallinks.io',
  'elena.tandara@reallinks.io',
];

export default {
  name: 'AdminLayout',
  data: () => ({
    companyList: [],
    user: null,
    form: {
      template: 'campaign-sandbox',
    },
    displayText: false,
    setupCompanyInstructions: null,
    isLoading: false,
  }),
  components: {
    AdvancedForm,
    LoadingSpinner
  },
  metaInfo: {
    titleTemplate: '%s — Real Links Admin',
    scripts: [
      { vmid: 'customJS', innerHTML: '' },
      { vmid: 'hotjar', innerHTML: '' },
    ],
  },
  beforeRouteEnter(to, from, next) {
    try {
      const { name, params: { companyID } } = to;
      const user = getCognitoUser();
      if (!user || !user.isValid) {
        return next({ name: 'Login', query: { next: to.path } });
      } else if (companyID && !EXCEMPT_ROUTES.includes(name) && companyID !== getCurrentCompanyID()) {
        return next({
          name: 'CompanyLogin',
          query: { next: to.path },
          params: { companyID },
        });
      } else if (companyID) {
        return next(async vm => {
          try {
            if (!vm.$root.company) {
              await companyStartSession(vm, { companyID });
            }
          } catch (err) {
            vm.$log.error(err);
          }
        });
      } else {
        next();
      }
    } catch (err) {
      Vue.$log.error(err);
      next(false);
    }
  },
  async beforeRouteUpdate(to, from, next) {
    try {
      const { name, params: { companyID } } = to;
      this.user = getCognitoUser();
      if (!this.user) {
        return next({
          name: 'Login',
          query: { next: to.path },
        });
      } else if (companyID && !EXCEMPT_ROUTES.includes(name) && companyID !== getCurrentCompanyID()) {
        return next({
          name: 'CompanyLogin',
          query: { next: to.path },
          params: { companyID },
        });
      } else {
        next();
      }
    } catch (err) {
      this.$log.error(err);
      next(false);
    }
  },
  created() {
    this.$root.admin = this;
    this.user = getCognitoUser();
  },
  mounted() {
    if (Array.isArray(this.companyList) && this.companyList.length) {
      this.$emit('admin-companyListFetched');
    } else if (this.user) {
      this.fetchCompanyList();
    }
  },
  computed: {
    ...mapRoot({
      currentCompany: 'company',
      isAdminLoggedIn: 'isLoggedIn',
    }),
    formFields() {
      const form = {
        companyName: {
          type: 'STRING',
          label: 'Company Name',
          required: true,
        },
        domain: {
          type: 'STRING',
          label: 'Domain',
          required: true,
          helpText: 'must be a reallinks.io domain.',
          validation: {
            minLength: 3,
          }
        },
        template: {
          type: 'SELECT',
          label: 'Template',
          placeholder: 'none',
          required: true,
          choices: {
            'campaign-sandbox': 'Campaign Sandbox',
            'standard': 'Standard Company'
          }
        },
        startDate: {
          type: 'DATETIME',
          label: 'Start Date',
          required: true,
          options: {
            format: 'YYYY-MM-DD HH:mm'
          }
        },
        jamDuration: {
          type: 'NUMBER',
          label: 'Jam Duration',
          required: true,
          placeholder: 'Please enter a whole number (of minutes).',
          helpText: 'number of minutes (e.g. \'30\' for 30 minutes)'
        }
      };

      return { form };
    },
    showAdminNavbar() {
      const { meta: { hideAdminNavbar = false } = {} } = this.$route;
      return hideAdminNavbar !== true;
    },
    companyID() {
      const { companyID } = this.$route.params;
      return companyID;
    },
    selectedCompany() {
      const { companyID, companyList } = this;
      return companyList.find(({ id }) => id === companyID);
    },
    companyDropdownList() {
      const activeList = this.companyList.filter(c => c && c.id && c.status === 'ACTIVE');
      return _sortBy(activeList, [ 'name', 'handle' ]);
    },
    isDeveloper() {
      const { emailAddress } = this.user || {};
      return emailAddress && DEVELOPER_EMAILS.includes(emailAddress);
    },
  },
  methods: {
    input() {
      console.log('input() returns: ', this.form);
      this.displayText = !this.displayText;
    },
    goBack() {
      this.displayText = !this.displayText;
    },
    async confirmInput() {
      this.isLoading = true;
      console.log('confirmInput() returns: ', this.form);
      try {
        const {
          companyName,
          domain,
          jamDuration,
          startDate,
          template: companyTemplate
        } = this.form;
        const { result } = await adminAPI({
          ServiceName: 'admin',
          FunctionName: 'companyCreate',
          Payload: {
            companyName,
            companyHandle: domain.replaceAll('.reallinks.io', ''),
            companyTemplate,
            jamStartDate: (new Date(startDate)).getTime(),
            jamDuration: jamDuration * 60 * 1000,
          }
        });
        if (result) {
          console.log({ result });
          await this.fetchCompanyList();
          this.setupCompanyInstructions = {
            magicLink: `https://${result.domainName}/company-setup?setup=true&eventID=${result.eventID}`,
          };
        }
      } catch (err) {
        this.isLoading = false;
        this.$notifyErr(err, { prepend: 'Failed to load company list' });
      }
      this.isLoading = false;
      console.log('Confirm Input has been executed.');
    },
    async fetchCompanyList() {
      try {
        const { result } = await adminAPI({ ServiceName: 'admin', FunctionName: 'companyList' });
        this.companyList = result && Array.isArray(result.list) ? result.list : [];
        this.$emit('admin-companyListFetched');
      } catch (err) {
        this.$notifyErr(err, { prepend: 'Failed to load company list' });
      }
    },
    refreshUser() {
      this.user = getCognitoUser();
    },
  },
  beforeDestroy() {
    this.$root.admin = null;
  },
};

export function mapAdmin(keys) {
  /**
   * Normalize the map
   * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
   * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
   * @link https://github.com/vuejs/vuex/blob/ffc7d00314a371c09d288bc5123793031d182cd2/src/helpers.js#L124-L135
   */
  const normalized = Array.isArray(keys)
    ? keys.map(key => ({ key, value: key }))
    : Object.keys(keys).map(key => ({ key, value: keys[key] }));
  return normalized.reduce((res, { key, value }) => {
    res[key] = function () {
      const { admin: data } = this.$root;
      return typeof value === 'function' ? value.call(this, data) : (data ? data[value] : null);
    };
    return res;
  }, {});
}
</script>

<style lang="scss">
.admin-layout {
  .navbar {
    z-index: 10;

    .admin-logo {
      margin-top: -8px;
      max-height: 20px;
    }

    .icon {
      display: inline-block;
      text-align: center;
      width: 15px;
    }
  }

  .navbar.bg-dark {
    .navbar-nav > li {
      a, p, strong {
        color: #fff !important;
      }
    }

    .navbar-nav > li {
      .dropdown-menu, .dropdown-item {
        background-color: #343a40;
      }
    }
  }

  .container, .container-fluid {
    min-height: 100%;
    position: relative;
    width: 100%;

    margin: 0 auto 0 auto;
    max-width: 1600px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/Admin.vue